<template lang="pug">
  dv-manageable-combo(
    v-bind="$attrs"
    v-on="$listeners"
    :method-create="methodCreate"
    :method-update="methodUpdate"
    :method-list="methodList"
    :form-schema="schema"
    :value="value"
    entity-name="Тег"
    entity-name-plural="Теги"
    entity-name-upsert="Тега"
    clearable
  )
</template>

<script>
import DvManageableCombo from '@/packages/ui/components/inputs/DvManageableCombo/DvManageableCombo.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';

export default {
  components: {
    DvManageableCombo,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    pollId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: [String, Number, Object, Array],
      default: undefined,
    },
  },
  data() {
    return {
      schema: [
        {
          name: 'name',
          label: 'Название',
          value: 'name',
          rules: 'required|max:512',
          component: DvTextField,
          rulesProps: (rules) => ({
            counter: rules?.max,
          }),
        },
      ],
    };
  },
  methods: {
    methodCreate({ data }) {
      const { $models, pollId } = this;
      const payload = {
        data: {
          ...data,
          event_poll_id: pollId,
        },
      };

      return $models.question.tag.create(payload);
    },
    methodUpdate({ args, data }) {
      const { $models, pollId } = this;
      const payload = {
        args,
        data: {
          ...data,
          event_poll_id: pollId,
        },
      };

      return $models.question.tag.update(payload);
    },
    methodList({ params }) {
      const { $models, pollId } = this;
      const payload = {
        params: {
          ...params,
          event_poll_id: pollId,
        },
      };

      return $models.question.tag.index(payload);
    },
  },
};
</script>
